export { getViewHomePageRoute, getEditHomePageRoute, getFlexiHelpCenterRoute } from './routes';
